<template>
  <div>
    <header-nav :cur="3"/>
    <!-- 搜索 -->
    <div class="nav">
      <div class="navtab">
                <span class="top">
                    首页&nbsp;>
                    <span class="infor">职能测试</span>
                </span>
        <div class="newbox">
          <div>
            <div class="newtop">职能测试</div>
            <div class="newbot">加入班级，更快速的成长</div>
          </div>
          <div class="input">
            <input placeholder="请输入您想要寻找的课程" type="text"/>
            <div class="select">搜索</div>
          </div>
        </div>
      </div>
    </div>

    <div class="functional">
		<div class="wd_cont">
		  <img src="../../assets/img/question/ts_iconn.svg"/>
		  <p>暂无课程,教师正在更新中...</p>
		</div>
      <!-- <ul>
        <li>
          <a href="#">
            <img src="#"/>
            <span>开始时间：2022-02-25</span>
          </a>
        </li>
        <li>
          <a href="#">
            <img src="#"/>
            <span>开始时间：2022-02-25</span>
          </a>
        </li>
        <li>
          <a href="#">
            <img src="#"/>
            <span>开始时间：2022-02-25</span>
          </a>
        </li>
        <li>
          <a href="#">
            <img src="#"/>
            <span>开始时间：2022-02-25</span>
          </a>
        </li>
        <li>
          <a href="#">
            <img src="#"/>
            <span>开始时间：2022-02-25</span>
          </a>
        </li>
        <li>
          <a href="#">
            <img src="#"/>
            <span>开始时间：2022-02-25</span>
          </a>
        </li>
        <li>
          <a href="#">
            <img src="#"/>
            <span>开始时间：2022-02-25 </span>
          </a>
        </li>
        <li>
          <a href="#">
            <img src="#"/>
            <span>开始时间：2022-02-25</span>
          </a>
        </li>
        <li>
          <a href="#">
            <img src="#"/>
            <span>开始时间：2022-02-25</span>
          </a>
        </li>
        <li>
          <a href="#">
            <img src="#"/>
            <span>开始时间：2022-02-25</span>
          </a>
        </li>
        <li>
          <a href="#">
            <img src="#"/>
            <span>开始时间：2022-02-25</span>
          </a>
        </li>
        <li>
          <a href="#">
            <img src="#"/>
            <span>开始时间：2022-02-25</span>
          </a>
        </li>
        <li>
          <a href="#">
            <img src="#"/>
            <span>开始时间：2022-02-25</span>
          </a>
        </li>
        <li>
          <a href="#">
            <img src="#"/>
            <span>开始时间：2022-02-25</span>
          </a>
        </li>
        <li>
          <a href="#">
            <img src="#"/>
            <span>开始时间：2022-02-25</span>
          </a>
        </li>
      </ul> -->
    </div>

    <v-pagination :total="total" :display='queryParams.pageSize' :current-page='queryParams.pageNum'
                  @pagechange="pagechange" style="padding-top: 80px;"></v-pagination>
    <!-- <paging /> -->
    <footer-nav/>
  </div>
</template>
<script>
import pagination from '@/components/common/pagination'
import headerNav from '../../components/HeaderNav.vue';
import footerNav from '../../components/FooterBar';
//import paging from '../../components/Paging.vue';
export default {
  components: {
    'v-pagination': pagination,
    'header-nav': headerNav,
    'footer-nav': footerNav,
  },
  data() {
    return {
      int: 100,
      sub_subject_int: 0,
      xxlx_int: 0,
      order: ['最新教程', '最多学习', '好评最多'],
      total: 1,
      pageCount: 1,
      pageSize: 12,
      pageNum: 1,
      clazz_list: [],
      xklx_list: [],
      ejxk_list: null,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        courseName: null,
        parentSubjectId: null,
        subjectId: null,
      },
    };
  },
  created() {
    this.queryParentSubjectList();
    this.getList();
  },
  methods: {
    pagechange(currentPage) {
      console.log(currentPage);
      this.queryParams.pageNum = currentPage;
      // ajax请求, 向后台发送 currentPage, 来获取对应的数据
      this.getList();
    },
    getList() {
      this.$http.get(this.$api.url + '/papi/clazz/list', {params: this.queryParams}).then((response) => {
        this.clazz_list = [];
        this.clazz_list = response.data.rows;
        this.total = response.data.total;
      }, (response) => {
        console.log("response" + response.data.rows.length);
      });
    },
    actli(id, int) {
      this.int = int;
      console.log(id);
      //this.querySubSubjectList(id);
      this.queryParams.parentSubjectId = id;
      this.getList();
    },
    queryParentSubjectList() {
      // Lambda写法
      this.$http.get(this.$api.url + '/papi/subject/queryParentSubjectList').then((response) => {
        this.xklx_list = [];
        this.xklx_list = response.data.data;
      }, (response) => {
        console.log("response" + response.data.length);
      });
    },
    querySubSubjectList(parentId) {
      // Lambda写法
      this.$http.get(this.$api.url + '/papi/subject/querySubSubjectList', {params: {'parentId': parentId}}).then((response) => {
        this.ejxk_list = response.data.data;
      }, (response) => {
        console.log("response" + response.data.length);
      });
    },
    actliSubSubjectId(id, int) {
      this.sub_subject_int = int;
      this.subSubjectId = id;
    },
    actli2(int) {
      this.int = int;
    },
    tolist(id) {
      //this.$router.push('/grade/list');
      this.$router.push({path: '/clazz/clazz-info', query: {id: id}});
    },
    toapply(id) {
      this.$router.push({path: '/clazz/inforregist', query: {id: id}});
    },
  },
};
</script>
<style lang="less" scoped>
@import url('./index.less');
</style>
<style lang="less" scoped>
.paging {
  width: 534px;
  height: 50px;
  background: rgba(112, 112, 112, 0.18);
  border-radius: 37px 37px 37px 37px;
  margin: 35px auto;
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #888888;
  justify-content: space-around;
  text-align: center;

  div {
    height: 50px;
    line-height: 50px;
    border-right: 1px solid rgba(112, 112, 112, 0.2);
    width: 20%;

    &:nth-child(5) {
      border: none;
    }
  }
}
</style>